<template>
  <div>
    <div>
      <el-dialog :visible.sync="visible" title="选择权限">

        <LoadingNoDialog :loading="menuLoading">
          <el-tree
            ref="tree"
            show-checkbox
            :data="data"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">

          </el-tree>
        </LoadingNoDialog>
        <el-button :loading="addLoading" @click="handleSure">
          确定
        </el-button>
      </el-dialog>

    </div>
  </div>
</template>

<script>
  import LoadingNoDialog from '../../../components/LoadingNoDialog.vue'
  import axios from 'axios'

  const moment = require('moment')
  export default {
    name: 'Menu',
    data() {
      return {
        data: [],
        menuLoading: false,
        addLoading: false,
        visible: false,
        roleId: 0
      }
    },
    components: {
      LoadingNoDialog
    },
    mounted() {
    },
    methods: {
      setVisible(role) {
        this.data=[]
        this.roleId = role.id
        this.visible = true
        this.getMenus()

      },
      async handleSure() {
        this.addLoading=true
        let keys = this.$refs.tree.getCheckedNodes()
        keys=keys.map(item=>item.key)
        keys = keys.map(item => item.split('-'))
        let postArra = []
        for (let key of keys) {
          postArra = [...postArra, ...key]
        }
        postArra = postArra.map(item => parseInt(item))
        postArra = Array.from(new Set(postArra))
        let r = await axios.post('/admin/role-to-resource', {
          roleId: this.roleId,
          resourceIds: postArra
        })
        this.visible=false
        this.addLoading=false
        this.$message.success('分配完成')
        this.$emit('sure')

      },
      async getMenus() {
        this.menuLoading = true
        let r = await axios.get('/admin/menus/resources-for-role', {params: {isResource: true}})
        let defaultResource=await axios.get('/admin/resource/role-resource',{params:{roleId:this.roleId}})
        this.data = r.data
        this.menuLoading = false
        this.$nextTick(()=>{
          console.info(defaultResource.data)
          let defaultIds=defaultResource.data.filter(item=>item.isLast==true).map(item=>item.id)
          console.info(defaultIds)
          this.$refs.tree.setCheckedKeys(defaultIds);
        })
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addClick() {
        this.addVisible = true
      },
      async remove(node, data) {
        this.$confirm('是否删除此菜单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let r = await axios.delete('/admin/menus/delete', {params: {menuId: data.id}})
          if (r.code == 123) {
            this.$message.warning('存在下级菜单，不可删除')
            return
          }
          this.getMenus()

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {

        })

      },

    }
  }
</script>




// WEBPACK FOOTER //
// src/main/permission/components/ResourceSelect.vue